import React, { useContext, useEffect, useState } from 'react'
import fetchMSSQLHook from '../../hooks/fetchMSSQL-hook'
import NoResults from '../../components/NoResults/NoResults'
import moment from 'moment'
import { NavigationContext } from '../../context/navigation-context'
import SearchFilter from "../../components/Filter/SearchFilter"

export default function Errors() {
    const [errors, setErrors] = useState([])
    const { fetchMssqlApi } = fetchMSSQLHook()
    const { setHeaderData } = useContext(NavigationContext)

    const reportList = [{ reportId: 95, reportColor: "primary" }];

    const defaultFilter = {
        dateTimeRangeFrom: moment().startOf("day").format("YYYY-MM-DDTHH:mm:ss"),
        dateTimeRangeTo: moment().endOf("day").format("YYYY-MM-DDTHH:mm:ss"),
        page: 1,
        rowsPerPage: 50,
        machineId: null,
        machineName: "",
        serialNo: "",
        locationId: null,
        locationName: "",
        machineTags: { id: [], name: [] },
        sortBy: "none",
    };

    const [filter, setFilter] = useState(defaultFilter);
    const [settingsFilter, setSettingsFilter] = useState({});

    const sortDefaults = {
        MachineName: "ASC",
        SerialNo: "ASC",
        CreateDateTime: "ASC",
        Comment: "ASC",
        ErrorName: "ASC",
        EventDescription: "ASC",
    };

    const getSortState = () => {
        const [field, dir] = String(filter.sortBy || "").split("|");
        return { field, dir: (dir || "").toUpperCase() };
    };

    const sortState = getSortState();

    const arrow = (field) => {
        if (sortState.field !== field) return "";
        return sortState.dir === "ASC" ? " ▲" : " ▼";
    };

    const handleHeaderSort = (field) => {
        const [curField, curDirRaw] = String(filter.sortBy || "").split("|");
        const curDir = (curDirRaw || "").toUpperCase();

        let nextDir;
        if (curField === field) {
            nextDir = curDir === "ASC" ? "DESC" : "ASC";
        } else {
            nextDir = sortDefaults[field] || "ASC";
        }

        const next = { ...filter, sortBy: `${field}|${nextDir}`, page: 1 };
        setFilter(next);
        searchErrors(next);
    };

    const getMachineIdsByTags = (machineTagIds) => {
        return new Promise((resolve, reject) => {
        fetchMssqlApi(
            "tags/getMachineIdsByTags",
            { method: "POST", hideNotification: true, data: { machineTagIds } },
            (response) => { resolve(JSON.stringify(response.map(Number).filter(Number.isFinite)) || [])},
            (err) => reject(err)
        );
        });
    };

    const searchErrors = async (f) => {
        let machineIds = "[]";
        if (f?.machineTags?.id?.length > 0) { machineIds = await getMachineIdsByTags(f.machineTags.id)} 
        if (f?.machineId) {const arr = JSON.parse(machineIds); arr.push(Number(f.machineId)); machineIds = JSON.stringify(arr);}
        fetchMssqlApi('machine-errors', { method: 'POST', hideNotification: true, data: {
            LocationId: f?.locationId,
            MachineIds: machineIds,
            FromCreateDateTime: f?.dateTimeRangeFrom,
            ToCreateDateTime: f?.dateTimeRangeTo,
            sortBy: f?.sortBy
        }}, res => {setErrors(res || [])});
    };

    useEffect(() => {
        setHeaderData({ text: 'Błędy maszyn' });
    }, []);

    return (
        <div className="container-fluid">
            <SearchFilter
                filterName="errors"
                defaultFilter={defaultFilter}
                reportList={reportList}
                onFilterChange={(f) => setFilter(f)}
                onSettingsChange={(s) => setSettingsFilter(s)}
                search={searchErrors}
                totalCount={errors.slice((filter.page - 1) * settingsFilter.rowsPerPage, filter.page * settingsFilter.rowsPerPage).length}
                forNow
            />
                <div className="card">
                    <div className="overflow-auto custom-scroll" style={{maxHeight: "calc(100vh - 150px)", overflowY: "auto"}}>
                    <table className="table table-striped">
                        <thead>
                            <tr className="justify-content-center headers-color">
                                <th
                                    className='text-center'
                                    style={{ cursor: "pointer", userSelect: "none" }}
                                    onClick={() => handleHeaderSort("MachineName")}
                                >
                                    Automat{arrow("MachineName")}
                                </th>
                                <th
                                    className='text-center'
                                    style={{ cursor: "pointer", userSelect: "none" }}
                                    onClick={() => handleHeaderSort("SerialNo")}
                                >
                                    Nr seryjny{arrow("SerialNo")}
                                </th>
                                <th
                                    className='text-center'
                                    style={{ cursor: "pointer", userSelect: "none" }}
                                    onClick={() => handleHeaderSort("CreateDateTime")}
                                >
                                    Data / czas{arrow("CreateDateTime")}
                                </th>
                                <th
                                    className='text-center'
                                    style={{ cursor: "pointer", userSelect: "none" }}
                                    onClick={() => handleHeaderSort("Comment")}
                                >
                                    Nr wyboru{arrow("Comment")}
                                </th>
                                <th
                                    className='text-center'
                                    style={{ cursor: "pointer", userSelect: "none" }}
                                    onClick={() => handleHeaderSort("ErrorName")}
                                >
                                    Błąd / Krytyczność{arrow("ErrorName")}
                                </th>
                                <th
                                    className='text-center'
                                    style={{ cursor: "pointer", userSelect: "none" }}
                                    onClick={() => handleHeaderSort("EventDescription")}
                                >
                                    Komentarz{arrow("EventDescription")}
                                </th>
                            </tr>
                        </thead>

                        <tbody>
                        {errors.slice((filter.page - 1) * settingsFilter.rowsPerPage, filter.page * settingsFilter.rowsPerPage).map((i) => (
                            <tr key={i.MachineEventId}>
                                <td className='text-center'>{i.MachineName}</td>
                                <td className='text-center'>{i.SerialNo}</td>
                                <td className='text-center'>{moment(i.CreateDateTime).format('YYYY-MM-DD HH:mm:ss')}</td>
                                <td className='text-center'>
                                <div className="d-flex w-100 justify-content-center align-items-center"
                                    style={{ fontSize: '120%', gap: "10px" }}>
                                    <span className="badge badge-success">{i.Comment}</span>
                                    <div className={`badge badge-${i.IsCritical ? 'danger' : 'warning'} p-1`}>Kod błędu: {i?.Code}</div>
                                </div>
                                </td>
                                <td className='text-center'>{i.ErrorName}</td>
                                <td className='text-center'>{i.EventDescription}</td>
                            </tr>
                            ))}
                        </tbody>
                    </table>
                    {errors?.length === 0 && <NoResults />}
                </div>
            </div>
        </div>
    );
}